import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../../request";
import { Get, Post, Put } from "../../../api";
import {
  UpdateCampaignStatusAction,
  UpdateCampaignStatusStateAction,
  UpdateOverviewReport,
  UpdateOverviewRequestStateAction,
} from "./action";
import { TransformOverviewResponse } from "./transformer";
import moment from "moment";
import { createStandaloneToast } from "@chakra-ui/react";

export function* overviewSaga() {
  yield takeLatest("overview-request-report", fetchReport);
  yield takeEvery("overview-update-campaign-status", updateCampaignStatus);
}

function* updateCampaignStatus(action: any) {
  const toast = createStandaloneToast();
  try {
    //yield put(UpdateOverviewRequestStateAction(RequestLoadingUpdate));
    // @ts-ignore
    yield call(Put, `/dashboard/campaigns/${action.id}/status`, {
      isActive: action.isActive,
    });
    yield put(UpdateCampaignStatusStateAction(action.id, action.isActive));
    toast({
      title: "Success",
      description: "Campaign status updated successfully",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    //yield put(UpdateOverviewRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    //yield put(UpdateOverviewRequestStateAction(RequestFailedUpdate));
  }
}

function* fetchReport(action: any) {
  try {
    yield put(UpdateOverviewRequestStateAction(RequestLoadingUpdate));

    const from = moment(action.from).format("YYYY-MM-DD");
    const until = moment(action.until).format("YYYY-MM-DD");
    const biddingType = action.biddingType;

    const url =
      biddingType === "all"
        ? `/dashboard/overview?from=${from}&until=${until}`
        : `/dashboard/overview?from=${from}&until=${until}&bidding_type_filter=${biddingType}`;

    // @ts-ignore
    const response = yield call(Get, url);
    yield put(UpdateOverviewReport(TransformOverviewResponse(response)));
    yield put(UpdateOverviewRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateOverviewRequestStateAction(RequestFailedUpdate));
  }
}
